'use strict';

exports.__esModule = true;
exports.isProduction = isProduction;
exports.getMarketplaceProductLines = getMarketplaceProductLines;
exports.getProvidersProductLine = getProvidersProductLine;
exports.getAdvisorsProductLine = getAdvisorsProductLine;
exports.isAppSmart = isAppSmart;
exports.getMatchingProductLine = getMatchingProductLine;
var IDENTITY_SUBSTRING_TEST = 'testappsmart.appdirect.com';
var IDENTITY_SUBSTRING_PROD = 'marketplace.appsmart.com';
var MARKETPLACE_PRODUCT_LINES_TEST = ['996', '1001', '918', '1004', '1007', '1002', '999'];
var MARKETPLACE_PRODUCT_LINES_PROD = ['1140', '1144', '1141', '1147', '1150', '1152', '1153'];
var PROVIDERS_PRODUCT_LINE_TEST = '1019';
var PROVIDERS_PRODUCT_LINE_PROD = '1158';
var ADVISORS_PRODUCT_LINE_TEST = '993';
var ADVISORS_PRODUCT_LINE_PROD = '1156';

function isProduction() {
    return window.location.href && window.location.href.includes(IDENTITY_SUBSTRING_PROD);
}

function getMarketplaceProductLines() {
    return isProduction() ? MARKETPLACE_PRODUCT_LINES_PROD : MARKETPLACE_PRODUCT_LINES_TEST;
}

function getProvidersProductLine() {
    return isProduction() ? PROVIDERS_PRODUCT_LINE_PROD : PROVIDERS_PRODUCT_LINE_TEST;
}

function getAdvisorsProductLine() {
    return isProduction() ? ADVISORS_PRODUCT_LINE_PROD : ADVISORS_PRODUCT_LINE_TEST;
}

function isAppSmart() {
    return window.location.href && (window.location.href.includes(IDENTITY_SUBSTRING_TEST) || isProduction());
}

function getMatchingProductLine(productLineNumber) {
    var productLines = [{
        productLineNumber: getAdvisorsProductLine(),
        filterValue: 'advisors'
    }, {
        productLineNumber: getProvidersProductLine(),
        filterValue: 'providers'
    }];

    // Return first result found
    return productLines.find(function (productLine) {
        return productLine.productLineNumber === productLineNumber;
    });
}